<div class="upp-overlay"
    tabindex="0"
    (click)="OnOverlayClick()"
    (keydown)="OnOverlayKeydown($event)"
>
    <div class="upp-overlay__panel"
        tabindex="0"
        (click)="OnPanelClick($event)"
        (keydown)="OnPanelKeydown($event)"
    >
        <ng-content></ng-content>
    </div>
</div>
